import { render, staticRenderFns } from "./IbSortButtons.vue?vue&type=template&id=1b6c6627&scoped=true"
import script from "./IbSortButtons.vue?vue&type=script&lang=js"
export * from "./IbSortButtons.vue?vue&type=script&lang=js"
import style0 from "./IbSortButtons.vue?vue&type=style&index=0&id=1b6c6627&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c6627",
  null
  
)

export default component.exports